module.exports = __webpack_public_path__ + "static/media/Skyfarm Drive, Santa Rosa, CA8.45e3f456.jpg";